import {
  ApplicationConfig,
  LOCALE_ID,
  APP_INITIALIZER,
  importProvidersFrom,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
  HttpClient,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { ExceptionInterceptor } from './core/interceptors/exception.interceptor';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { AuthConfigService } from './core/services/auth/auth-config.service';
import { registerLocaleData } from '@angular/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import ru from '@angular/common/locales/ru';
import { APP_ROUTES } from './app.routes';
import { ToastService } from '@ui-lib/components';

import {
  BffAdminApiConfiguration,
  BffAdminApiModule,
} from './core/openapi/bff-admin-api';
import { environment } from '../environments/environment';
import { LocalStorageService } from './core/services/storage/local-storage.service';
import {
  IdentityApiConfiguration,
  IdentityApiModule,
} from './core/openapi/identity';
import { LanguageService } from './core/services/language/language.service';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

// Register locale data
registerLocaleData(ru);

// Factory function for TranslateHttpLoader
export function HttpLoaderFactory(httpClient: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(httpClient, 'assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(APP_ROUTES),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideCharts(withDefaultRegisterables()),
    provideOAuthClient(),
    ToastService,
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'ru',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
      IdentityApiModule.forRoot(() => {
        return new IdentityApiConfiguration({
          basePath: environment.apiUrls.identity,
        });
      }),
      BffAdminApiModule.forRoot(() => {
        return new BffAdminApiConfiguration({
          basePath: environment.apiUrls.bffAdmin,
        });
      }),
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ExceptionInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (authConfigService: AuthConfigService) => {
        return () => authConfigService.configureOAuth();
      },
      multi: true,
      deps: [AuthConfigService],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (languageService: LanguageService) => {
        return () => languageService.initCurrentLanguage();
      },
      multi: true,
      deps: [LanguageService],
    },
    LocalStorageService,
    AuthConfigService,
    LanguageService,
    {
      provide: LOCALE_ID,
      useValue: 'ru-RU',
    },
  ],
};
